import React from 'react'

export const AppCloudUploadIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 13.75L10 8.125M10 8.125L12.5 10.625M10 8.125L7.5 10.625M5.625 16.25C3.55393 16.25 1.875 14.5711 1.875 12.5C1.875 10.8392 2.95463 9.43058 4.45033 8.93766C4.40087 8.67433 4.375 8.40269 4.375 8.125C4.375 5.70875 6.33375 3.75 8.75 3.75C10.776 3.75 12.4804 5.12717 12.9781 6.99646C13.2212 6.91761 13.4806 6.875 13.75 6.875C15.1307 6.875 16.25 7.99429 16.25 9.375C16.25 9.66512 16.2006 9.94369 16.1097 10.2028C17.2878 10.6504 18.125 11.7899 18.125 13.125C18.125 14.8509 16.7259 16.25 15 16.25H5.625Z"
        stroke="#5E5E5E"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
